import { ts } from 'src/utils/translate';

export const FloorMap = (props: any) => {
  const { wiringTextNeeded, enabled, floorMapObj } = props;

  return floorMapObj && floorMapObj.cachedFloor ? (
    <div
      style={{ position: "relative" }}
      className={`map-center-align map-comp-root quote-map ${enabled ? "" : "quote-map-hidden"}`}
    >
      {wiringTextNeeded ? (
        <div
          className="floormap-info-box"
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            color: "#5d5d5d",
            fontSize: 12,
            textAlign: "right",
            padding: "1px 4px",
            background: "#ffffffe0",
          }}
        >
          {ts(
            "q_wiring_nocontain",
            "This plan does not contain cabling instructions for the following functions: blank inserts, generic cable outlets, thermostats, HDMI cables, speaker connectors, generic audio outputs."
          )}
        </div>
      ) : null}
      {floorMapObj.cachedFloor}
    </div>
  ) : null;
};
